module.exports = __webpack_public_path__ + "static/media/designsystem.c4c706bf.png";